function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

(function () {
  "use strict";

  try {
    if ((typeof document === "undefined" ? "undefined" : _typeof(document)) < "u") {
      var e = document.createElement("style");
      e.appendChild(document.createTextNode(".cdx-underline{text-decoration:underline}")), document.head.appendChild(e);
    }
  } catch (n) {
    console.error("vite-plugin-css-injected-by-js", n);
  }
})();

var r = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24"><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 7.5V11.5C9 12.2956 9.31607 13.0587 9.87868 13.6213C10.4413 14.1839 11.2044 14.5 12 14.5C12.7956 14.5 13.5587 14.1839 14.1213 13.6213C14.6839 13.0587 15 12.2956 15 11.5V7.5"/><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M7.71429 18H16.2857"/></svg>',
    s = /*#__PURE__*/function () {
  /**
   * @param options InlineToolConstructorOptions
   */
  function s(e) {
    _classCallCheck(this, s);

    this.tag = "U", this.api = e.api, this.iconClasses = {
      base: this.api.styles.inlineToolButton,
      active: this.api.styles.inlineToolButtonActive
    };
  }
  /**
   * Class name for term-tag
   *
   * @type {string}
   */


  _createClass(s, [{
    key: "render",
    value:
    /**
     * Create button element for Toolbar
     *
     * @returns {HTMLElement}
     */
    function render() {
      return this.button = document.createElement("button"), this.button.type = "button", this.button.classList.add(this.iconClasses.base), this.button.innerHTML = this.toolboxIcon, this.button;
    }
    /**
     * Wrap/Unwrap selected fragment
     *
     * @param {Range} range - selected fragment
     */

  }, {
    key: "surround",
    value: function surround(e) {
      if (!e) return;
      var t = this.api.selection.findParentTag(this.tag, s.CSS);
      t ? this.unwrap(t) : this.wrap(e);
    }
    /**
     * Wrap selection with term-tag
     *
     * @param {Range} range - selected fragment
     */

  }, {
    key: "wrap",
    value: function wrap(e) {
      var t = document.createElement(this.tag);
      t.classList.add(s.CSS), t.appendChild(e.extractContents()), e.insertNode(t), this.api.selection.expandToTag(t);
    }
    /**
     * Unwrap term-tag
     *
     * @param {HTMLElement} termWrapper - term wrapper tag
     */

  }, {
    key: "unwrap",
    value: function unwrap(e) {
      var o;
      this.api.selection.expandToTag(e);
      var t = window.getSelection();
      if (!t) return;
      var n = t.getRangeAt(0);
      if (!n) return;
      var i = n.extractContents();
      i && ((o = e.parentNode) == null || o.removeChild(e), n.insertNode(i), t.removeAllRanges(), t.addRange(n));
    }
    /**
     * Check and change Term's state for current selection
     */

  }, {
    key: "checkState",
    value: function checkState() {
      var t;
      var e = this.api.selection.findParentTag(this.tag, s.CSS);
      return (t = this.button) == null || t.classList.toggle(this.iconClasses.active, !!e), !!e;
    }
    /**
     * Get Tool icon's SVG
     *
     * @returns {string}
     */

  }, {
    key: "toolboxIcon",
    get: function get() {
      return r;
    }
    /**
     * Sanitizer rule
     *
     * @returns {{u: {class: string}}}
     */

  }], [{
    key: "CSS",
    get: function get() {
      return "cdx-underline";
    }
  }, {
    key: "sanitize",
    get: function get() {
      return {
        u: {
          class: s.CSS
        }
      };
    }
  }]);

  return s;
}();

s.isInline = !0;
var a = s;
export { a as default };